/**
 * Tools routing configuration
 * Flat routes - one entry per tool page.
 */

import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import ToolsHub from './ToolsHub'
import FpUserGuard from '../../../components/FpUserGuard'

import DuplicateSales from './tools/DuplicateSales'
import CogsAccountReview from './tools/CogsAccountReview'
import InventoryBalanceReview from './tools/InventoryBalanceReview'
import ProductCatalogueReview from './tools/ProductCatalogueReview'

const ToolsRoutes: React.FC = () => {
  return (
    <Routes>
      <Route index element={<ToolsHub />} />

      <Route path="duplicate-sales" element={<FpUserGuard kind="tool" id="duplicate_invoices"><DuplicateSales /></FpUserGuard>} />
      <Route path="cogs-review" element={<FpUserGuard kind="tool" id="cogs_review"><CogsAccountReview /></FpUserGuard>} />
      <Route path="inventory-balance" element={<FpUserGuard kind="tool" id="inventory_balance_review"><InventoryBalanceReview /></FpUserGuard>} />
      <Route path="product-catalogue-review" element={<FpUserGuard kind="tool" id="product_catalogue_review"><ProductCatalogueReview /></FpUserGuard>} />

      <Route path="*" element={<Navigate to=".." replace />} />
    </Routes>
  )
}

export default ToolsRoutes
